export default __webpack_public_path__ + "static/icon-24-4-1002dfecb21bb39520f83265f994a214.png";